<template>
  <div class="fb-banner text-center">
    <h2>{{ $t("wegow.banner.fbFriends.title") }}</h2>
    <wegow-button
      button-id="banner-fb-button"
      background="opacity"
      color="topaz"
      size="xl"
      type="button"
      :text="$t('wegow.banner.fbFriends.button')"
      @click="
        sendGa('sign-up');
        openModal(SIGN_UP);
      "
    />
  </div>
</template>

<script setup>
import WegowButton from "@/components/general/forms/WegowButton";
import { useModalHandler } from "@/plugins/useModalHandler";

const { SIGN_UP, openModal } = useModalHandler();
</script>

<style scoped lang="scss">
.fb-banner {
  justify-content: flex-start;
  height: 370px !important;
  width: 100%;
  background-image: url("@/assets/images/conect-friends-fb-banner.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white !important;
  h2 {
    font-weight: 600;
    font-size: 2.5rem;
    line-height: 48px;
    margin: 0px 234px 46px 234px;
  }
  @media screen and (max-width: 800px) {
    h2 {
      margin: 0px 50px 46px 50px;
      font-size: 1.5rem;
    }
  }
  p {
    font-weight: 400;
    font-size: 25px;
    line-height: 30px;
    margin-top: 11px;
    margin-bottom: 40px;
  }
  #banner-fb-button {
    padding: 6px 19px;
    font-size: 25px;
    width: 177px;
    height: 45px;
    box-sizing: border-box;
  }
}
</style>
